import {getDateUtilDefaultInstance} from '/util/date.util';

export const handleNewLabel = ({item}: any) => {
  const dateUtil = getDateUtilDefaultInstance();
  const dateAddedOn = new Date(item.createdTs);
  const currentDate = dateUtil.getNow();

  return dateUtil.showDate(dateAddedOn) === dateUtil.showDate(currentDate);
};
